import React, { useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	Button,
} from '@chakra-ui/react'
import { InputText, Form } from '../../components/form'
import { fetchWrapper } from '../../helpers';

function Create({ customer_id, loadList, meCloseEdit }) {



	const [formData, setFormData] = useState({
		username: '',
		email: '',
		password: '',
		customer_id: customer_id,
		confirmPassword: ""

	});

	const FormSchema = Yup.object().shape({
		username: Yup.string().required('Required'),
		email: Yup.string()
			.email('Invalid email address')
			.required('Email is required'),

		password: Yup.string()
			.min(8, 'Password must be at least 8 characters')
			.matches(/\d/, 'Password must contain at least one digit')
			.matches(/[a-zA-Z]/, 'Password must contain at least one letter')
			.matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
			.required('Password is required'),
		confirmPassword: Yup.string()
			.oneOf([Yup.ref('password'), null], 'Passwords must match') // Ensure passwords match
			.required('Required'),

	});








	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

	

		const payload = { customer_id: customer_id, email: values?.email, password: values?.password, username: values?.username,super_admin:1 }
		const url = `${process.env.REACT_APP_API_URL}/user/create`;
		const response = await fetchWrapper.post(url, payload)
		loadList()
		meCloseEdit()
		

	}

	return (


		<Form
			enableReinitialize
			validationSchema={FormSchema}
			initialValues={formData}
			onSubmit={onSubmit}
		>

			<Box mb="10px">
				<InputText name="username" title="Full Name" />
			</Box>
			<Box mb="10px">
				<InputText name="email" title="Email " />
			</Box>
			<Box mb="10px">
				<InputText name="password" title="Password" inputProps={{ type: 'password' }} />
			</Box>
			<Box mb="10px">
				<InputText name="confirmPassword" title="Confirm Password" inputProps={{ type: 'password' }} />
			</Box>





			<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
				mb={4}

				type='submit'
			>
				Add New User
			</Button>
		</Form>


	)
}

export default Create;